import { apiOrigin } from "../api/config";

const listeners = new Set();
let socket = null;
let reconnectTimer = null;
let reconnectAttempts = 0;
let manuallyClosed = false;

function socketUrl() {
  const origin = apiOrigin() || window.location.origin;
  const websocketOrigin = origin.replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
  return `${websocketOrigin.replace(/\/$/, "")}/ws?client=admin`;
}

function emit(payload) {
  listeners.forEach((listener) => {
    try { listener(payload); } catch (error) { /* 单个页面异常不影响其他订阅者。 */ }
  });
}

function scheduleReconnect() {
  if (manuallyClosed || reconnectTimer) return;
  const delay = Math.min(1000 * (2 ** reconnectAttempts), 15000);
  reconnectAttempts += 1;
  reconnectTimer = window.setTimeout(() => {
    reconnectTimer = null;
    connect();
  }, delay);
}

export function connect() {
  const token = window.localStorage.getItem("admin_token");
  if (!token || (socket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(socket.readyState))) return;
  manuallyClosed = false;
  try {
    socket = new WebSocket(socketUrl(), ["realtime-v1", `auth.${token}`]);
  } catch (error) {
    scheduleReconnect();
    return;
  }
  socket.onopen = () => {
    reconnectAttempts = 0;
    emit({ event: "realtime.connected", data: {} });
  };
  socket.onmessage = (event) => {
    try { emit(JSON.parse(event.data)); } catch (error) { /* 忽略非 JSON 心跳或异常帧。 */ }
  };
  socket.onerror = () => {};
  socket.onclose = () => {
    socket = null;
    emit({ event: "realtime.disconnected", data: {} });
    scheduleReconnect();
  };
}

export function disconnect() {
  manuallyClosed = true;
  if (reconnectTimer) window.clearTimeout(reconnectTimer);
  reconnectTimer = null;
  reconnectAttempts = 0;
  if (socket) socket.close(1000, "page closed");
  socket = null;
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
